import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { ComponentsModule } from "@components";
import { SlickAutoCompleteModule, SlickContainerModule, SlickDialogModule, SlickTabsModule } from "@slick-components";

import { TextChatConversationsComponent } from "./text-chat-conversations.component";

@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		ComponentsModule,
		SlickAutoCompleteModule, SlickContainerModule, SlickDialogModule, SlickTabsModule
	],
	declarations: [TextChatConversationsComponent],
	exports: [TextChatConversationsComponent]
})
export class TextChatConversationsModule { }


